import { ReactElement } from "react";
import { IFormHandler } from "client/Forms";
import { localize } from "client_legacy/ndaw/culture";
import { ActivityFeedSettingsState } from "./NotificationSettingsDialog";
import { NotificationSection } from "./NotificationSection";

export type EmailActivitySectionProps = {
	formHandler: IFormHandler<ActivityFeedSettingsState>;
};

export const EmailActivitySection = (props: EmailActivitySectionProps): ReactElement => {
	const { formHandler } = props;

	return (
		<NotificationSection
			title={localize("_Email")}
			trackingId="email"
		>
			<NotificationSection.ItemList>
				<NotificationSection.Item
					label={localize("_Emails")}
					subtext={localize("_EmailsActivityDescription")}
					attachable={formHandler.for("newEmails")
						.for("isEnabled")
						.attachToCheckbox()
					}
				/>
			</NotificationSection.ItemList>
		</NotificationSection>
	);
};

EmailActivitySection.displayName = "EmailActivitySection";
